import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { DocumentRequest } from '@models/document-request';
import { TiimeButtonModule } from 'tiime-material';
import { DocumentRequestModuleTypeLabelPipe } from '@shared-pipes/document-request-module-type-label/document-request-module-type-label.pipe';
import { DatePipe } from '@angular/common';
import { DocumentRequestStatusLabelPipe } from '@shared-pipes/document-request-status-label/document-request-status-label.pipe';
import { Store } from '@ngrx/store';
import { AppStoreState } from '@interfaces/app-store-state';
import { accountingPeriodsSelector } from '@modules/company/company-core/store/accounting-periods/accounting-periods-selector';

@Component({
  selector: 'app-document-request',
  standalone: true,
  imports: [TiimeButtonModule, DocumentRequestModuleTypeLabelPipe, DatePipe, DocumentRequestStatusLabelPipe],
  templateUrl: './document-request.component.html',
  styleUrl: './document-request.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentRequestComponent {
  readonly documentRequest = input.required<DocumentRequest>();
  readonly selectDocumentRequest = output<void>();
  readonly openOrCloseDocumentRequest = output<void>();
  readonly store: Store<AppStoreState> = inject(Store);

  readonly accountingPeriod = computed(() => {
    const documentRequest = this.documentRequest();
    const accountingPeriods = this.store.selectSignal(accountingPeriodsSelector)();

    return accountingPeriods?.find(ap => ap.id === documentRequest.accountingPeriodId);
  });

  onCloseDocumentRequestClick(event: MouseEvent): void {
    event.stopPropagation();
    this.openOrCloseDocumentRequest.emit();
  }
}
